import {
  parseToKyiv, 
  nowInKyiv,
} from "./dateTime";
export const isRealDate = (value: string | Date | null): boolean => {
  const date = parseToKyiv(value);
  if (!date || !date.isValid) return false;

  const currentYear = nowInKyiv().year;
  const dateYear = date.year;

  if (dateYear < 1900 || (dateYear - 100) > currentYear) return false;

  return true;
};

